import { mq, paddingV } from '@sleepstation/style-api-helpers'
import { outset } from '@sleepstation/style-mixins'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import Card from './Card'
import Deck from './Deck'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  width: 100vw;

  ${mq(`smallUp`)} {
    ${outset()}
    ${paddingV([1.75])}
    max-width: 616px;
  }

  ${mq(`mediumUp`)} {
    max-width: 698px;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const WelcomeDeck = ({ deck }) => (
  <Layout>
    <Deck deck={deck} renderer={Card} />
  </Layout>
)

WelcomeDeck.propTypes = {
  deck: PropTypes.object.isRequired,
}

export default WelcomeDeck
